"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const errorNotification_1 = require("../errorNotification");
const api_1 = require("../api");
const react_svg_1 = require("react-svg");
const ImageList = (0, react_1.forwardRef)((props, ref) => {
    const [changingOrder, setChangingOrder] = (0, react_1.useState)(false);
    const [pictures, setPictures] = (0, react_1.useState)(props.selectedRecord ? props.selectedRecord.images : []);
    const picturesApi = new api_1.PicturesApi();
    const loadRecord = async (plantId) => {
        const { pictures } = await picturesApi.index({ modelId: plantId });
        setPictures(pictures);
    };
    (0, react_1.useImperativeHandle)(ref, () => ({
        reloadImages(modelId) {
            loadRecord(modelId);
        }
    }));
    (0, react_1.useEffect)(() => {
        if (props.selectedRecord)
            loadRecord(props.selectedRecord.modelId);
        if (props.selectedRecord == null)
            setPictures([]);
    }, [props.selectedRecord]);
    const handleDeletePicture = async (id, file_name) => {
        if (!confirm(`Möchten Sie eine Datei ${file_name} löschen?`)) {
            return;
        }
        try {
            const { success } = await picturesApi.delete(id);
            if (success)
                setPictures(pictures.filter(image => image.id !== id));
        }
        catch (error) {
            (0, errorNotification_1.notify)('error', error.message);
        }
    };
    const handleRotation = async (id, direction) => {
        let orientation = 90;
        if (direction === 'left') {
            orientation = -90;
        }
        await updateImage(id, { orientation });
    };
    const updateImage = async (id, payload) => {
        try {
            const { success, picture } = await picturesApi.update(id, payload);
            if (success) {
                // replace updated image with new image
                const index = pictures.findIndex((picture) => picture.id == id);
                let tmp = [...pictures];
                tmp.splice(index, 1, picture);
                setPictures(tmp);
            }
        }
        catch (error) {
            (0, errorNotification_1.notifyError)(error);
        }
    };
    const handleMainImage = async (picture) => {
        setChangingOrder(true);
        try {
            await picturesApi.update(picture.id, { main: true });
            const { modelId } = props.selectedRecord;
            await loadRecord(modelId);
        }
        catch (error) {
            (0, errorNotification_1.notifyError)(error);
        }
        setChangingOrder(false);
    };
    const handleFloramediaChange = (picture) => (async (event) => {
        setChangingOrder(true);
        try {
            await picturesApi.update(picture.id, { floramedia: event.target.checked });
            const { modelId } = props.selectedRecord;
            await loadRecord(modelId);
        }
        catch (error) {
            (0, errorNotification_1.notifyError)(error);
        }
        setChangingOrder(false);
    });
    return (react_1.default.createElement("div", { className: changingOrder ? 'opacity-50' : '' },
        react_1.default.createElement("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2" }, pictures.map(image => (react_1.default.createElement("div", { key: image.id, className: "bg-white overflow-hidden shadow rounded-lg" },
            react_1.default.createElement("div", { className: "p-2" },
                react_1.default.createElement("div", { className: 'flex justify-between pb-1' },
                    react_1.default.createElement("button", { className: 'w-4 hover:text-black text-gray-500', onClick: () => handleRotation(image.id, 'left') },
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: '/images/rotate-left.svg' })),
                    react_1.default.createElement("button", { onClick: handleDeletePicture.bind(this, image.id, image.name), className: "rounded-md inline-flex hover:text-black text-gray-500 focus:outline-none focus:ring-none" },
                        react_1.default.createElement("span", { className: "sr-only" }, "Close"),
                        react_1.default.createElement("svg", { className: "h-5 w-5", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" },
                            react_1.default.createElement("path", { fillRule: "evenodd", d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z", clipRule: "evenodd" }))),
                    react_1.default.createElement("button", { className: 'w-4 hover:text-black text-gray-500', onClick: () => handleRotation(image.id, 'right') },
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: '/images/rotate-right.svg' }))),
                react_1.default.createElement("div", { className: "h-40 overflow-hidden mb-2 relative" },
                    react_1.default.createElement("img", { className: "object-contain h-full w-full", src: image.thumbUrl })),
                react_1.default.createElement("div", { className: "mb-1 text-gray-900 text-xs text-center" },
                    react_1.default.createElement("span", { className: 'break-all' }, image.name)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("label", { className: "mb-1 text-gray-900 text-xs flex items-center cursor-pointer" },
                        react_1.default.createElement("input", { name: "selectedView", type: "checkbox", checked: !!(image.main), onClick: handleMainImage.bind(this, image), readOnly: true, className: "mr-2 cursor-pointer checkboxx" }),
                        "Hauptbild"),
                    react_1.default.createElement("label", { className: "text-gray-900 text-xs flex items-center cursor-pointer" },
                        react_1.default.createElement("input", { name: "selectedView", type: "checkbox", checked: (image.floramedia), onClick: handleFloramediaChange(image), readOnly: true, className: "mr-2 cursor-pointer checkboxx" }),
                        "Floramedia")))))))));
});
exports.default = ImageList;
